<template>
    <div>
        <div v-if="autoMode" class="title-valid-button">Exemple de contenu généré automatiquement</div>
        <div class="send-button">Complétez votre adhésion en cliquant ici</div>

        <p>Ou copiez/collez dans votre navigateur le lien suivant :<br>
            https://hubo.relance-tourisme.fr/reponse/*************/{{ slug() }}</p>
    </div>
</template>

<script>
    import slugify from 'slugify'

    export default {
        name: "FormLink",
        props: ['generated', 'name'],
        data() {
            return {
                autoMode: false
            }
        },
        methods: {
            slug() {
                return slugify(this.name)
            }
        },
        created() {
            if(this.generated !== undefined) {
                this.autoMode = true
            }
        }
    }
</script>